import { Heading5 } from 'app/ui-components/typography/Heading.styles';
import { errorStatistics } from 'app/utils/statistics/universalStatistics';
import { useRouter } from 'next/router';
import * as React from 'react';
import SendStatistics from '../CommonElements/SendStatistics';
import { ErrorContainer, RightsLink, Description } from './VideoModal.styles';
import PlayText, { SIZE } from 'app/ui-components/typography/PlayText/PlayText';
import TopBar from '../VideoPlayer/Plugins/TopBar/TopBar';

const MissingContent = () => {
    return (
        <>
            <Heading5>Programmet kunde inte hittas</Heading5>
            <Description>
                Det här programmet är inte tillgängligt, vilket kan bero på att det är avpublicerat
            </Description>
            <Description>
                <RightsLink href="https://kontakt.svt.se/guide/rattigheter">
                    <PlayText size={SIZE.DEFAULT} as="span">
                        Hur funkar upphovsrätt i SVT Play?
                    </PlayText>
                </RightsLink>
            </Description>
        </>
    );
};

const UnknownError = () => {
    return (
        <>
            <Heading5>Programmet kunde inte laddas</Heading5>
            <Description>
                Vi ber om ursäkt, men just nu går det inte att spela programmet. Klicka på Tillbaka och försök
                igen.
            </Description>
        </>
    );
};

export const Error = React.forwardRef(({ error }, ref) => {
    const router = useRouter();

    const isError = error;
    const code = isError ? 500 : 404;

    return (
        <ErrorContainer ref={ref}>
            <TopBar />
            {isError ? <UnknownError /> : <MissingContent />}
            <SendStatistics statisticsObject={errorStatistics(code, router.asPath)} />
        </ErrorContainer>
    );
});

export default Error;
